<template>
    <div class="w100 bgDark">
        <div class="wContent center">
            <ul class="menu">
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['关于我们']">关于我们</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['服务体系']">服务体系</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['网站地图']">网站地图</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['首页']">首页</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['资讯']">资讯</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['研报']">研报</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['价格指数']">价格指数</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['基准价']">基准价</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['报价']">报价</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['期现']">期现</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['钢坯调期']">钢坯调期</router-link></li>
                <li class="floatLeft"><router-link class="block textCenter menu-child" :to="navigationUrl['数据']">数据</router-link></li>
            </ul>
            <div class="clear"></div>
            <el-row class="contcats textCenter">
                
                <el-col :span="18">
                    <div class="grid-content fontLighter part-2">
                        <p>河北唐宋大数据产业股份有限公司</p>
                        <p>CopyRight© 2005-2030 钢铁产业网 All Rights Reserved E-mail: info@chinatsi.com</p>
                        <p><a href="http://beian.miit.gov.cn" target="_blank" rel="" class="fontLighter">冀ICP备10012213号-3</a></p>
                        <div>
                            <img src="../assets/images/beian.png" alt="" style="width: auto;">
                            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13024002000160">
                                <img src="" />
                                <span style="margin: -15px 0px 0px 5px;" class="fontLighter inlineBlock vMid">冀公网安备 13024002000160号</span>
                            </a>
                        </div>
                        <p>客服电话：400 6565 958</p>
                        <a href='https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=9113020077132111X4-SAIC_SHOW_1000009113020077132111X41597218022033&signData=MEYCIQCxM3W+K2bvqLfxERDB076afk1X0Oit+hqKllKJ012LWgIhAJvc0y0J+hSw2vmYxWb17XFuh5Re0OT5kNnnHbObAm+c' target='_blank' style='border:0;'>
                            <img src='../assets/images/memory.action.png' style='border:0;'/>
                        </a>
                        
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content part-3">
                        <img src="../assets/images/footer_down.png" alt="" srcset="">
                        <!-- <div class="inlineBlock vTop fontWhite font14 down">
                            <span class="block textCenter">Android版下载</span>
                            <span class="block textCenter">iphone版下载</span>
                        </div> -->
                        <p class="textLeft">唐宋钢铁APP</p>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content part-1">
                        <img src="../assets/images/footer_code.png" alt="" srcset="">
                        <p class="textCenter fontLighter" style="padding-top: 10px">唐宋大数据</p>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { navigationUrl } from '../assets/js/common'
export default {
    name: 'Footer',
    components: {},
    data () {
        return {
            navigationUrl: navigationUrl
        }
    },
    mounted () {
        // 初始化内容
        this.init();
    },
    methods: {
        //页面操作
        init () {
        }
    },
}
</script>

<style scoped>
    .menu { margin: 0 5px; padding: 0 10px; border-bottom: 1px solid #aaaaaa; height: 50px; }
    .menu-child { height: 50px; line-height: 50px; width: 90px; color: #aaaaaa; }
    .contcats { padding: 20px 10px; }
    .part-1, .part-3 { margin-top: 30px; }
    .part-1 img { width: 90px; }
    .part-2 p { line-height: 25px; }
    .part-2 img { width: 30px; margin-top: 10px; }
    .part-3 img { width: 90px; }
    .part-3 p { margin-top: 10px; color: #aaa; padding-left: 38px; }
    .part-3 .down { padding-top: 0px; padding-left: 10px; }
    .part-3 .down span { background: rgba(255, 255, 255, 0.1); width: 105px; height: 24px; line-height: 24px; margin-top: 10px; }
</style>